import dayjs from 'dayjs';
import { StyledDateBox, StyledDateText } from './DateBox.styles';
import { Typography } from '@mui/material';

export const DateBox = ({ date, onClick, theme }) => {
  const today = dayjs().startOf('day');
  const formattedDate = dayjs(date);

  const isPastDate = formattedDate.isBefore(today);
  const isToday = formattedDate.isSame(today, 'day');

  return (
    <StyledDateBox isToday={isToday} onClick={onClick}>
      <StyledDateText isPastDate={isPastDate}>
        <Typography variant="body1">{formattedDate.format('ddd')}</Typography>
        <Typography variant="bodyRegular">{formattedDate.date()}</Typography>
      </StyledDateText>
    </StyledDateBox>
  );
};
